import { render, staticRenderFns } from "./AttributeColor.vue?vue&type=template&id=3ee27954&"
import script from "./AttributeColor.vue?vue&type=script&lang=js&"
export * from "./AttributeColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports